import { P, Pivot, R, Segments } from "apparatus/library/common";
import { Group, Path, Shape, Symbol } from "paper";
export class WireGauze {
    render(appearance) {
        switch (appearance.view) {
            case "side":
                return sideView(appearance);
            case "top":
                return topView(appearance);
            case "3d":
                return threeDView(appearance);
        }
    }
}
WireGauze.properties = {
    label: "Wire Gauze",
    defaultAppearance: {
        size: 100,
        view: "side",
    },
    appearanceSpecs: [
        {
            spec: "slider", key: "size", label: "Size",
            min: 50, max: 150, step: 10, unit: "mm"
        },
        {
            spec: "toggle-buttons", key: "view", label: "View", size: "text",
            options: [
                { value: "top", label: "Top" },
                { value: "3d", label: "3D" },
                { value: "side", label: "Side" },
            ]
        }
    ],
};
function sideView(appearance) {
    let squiggle = new Path(Segments([[0, 0], undefined, [5, 9]], [[10, 0], [-5, -9], [5, 9]]));
    squiggle.strokeWidth = 2.5;
    squiggle.strokeColor = "#5c6c84";
    let count = appearance.size / 10;
    let graphic = new Group([squiggle]);
    for (var i = 2; i < count; i++) {
        squiggle.addSegments(Segments([[i * 10, 0], [-5, -9], [5, 9]]));
    }
    return {
        graphic: graphic,
        hitShape: graphic.strokeBounds.expand(10).toShape(),
        snapping: [{
                type: "placeable",
                at: graphic.bounds.bottomCenter.add(P(0, 5)),
            }, {
                type: "placeable_surface",
                start: graphic.bounds.topLeft.add(P(0, -5)),
                end: graphic.bounds.topRight.add(P(0, -5))
            }]
    };
}
function topView(appearance) {
    let line = Shape.Rectangle(R(0, 0, appearance.size, 2.0));
    line.fillColor = "#5c6c84";
    let lineSymbol = new Symbol(line, true);
    let count = appearance.size / 10;
    let offset = appearance.size / 2 + 5;
    let graphic = new Group();
    for (var i = 1; i < count + 1; i++) {
        graphic.addChild(lineSymbol.place(P(0, 10 * i - offset)));
        let orthogonalPlaced = lineSymbol.place(P(i * 10 - offset, 0));
        orthogonalPlaced.rotate(90);
        graphic.addChild(orthogonalPlaced);
    }
    let pad = Shape.Circle(graphic.bounds.center, appearance.size / 3);
    pad.fillColor = "#dbcfbaee";
    graphic.addChild(pad);
    var hitShape = Shape.Rectangle(graphic.strokeBounds.expand(10));
    return { graphic: graphic, hitShape: hitShape };
}
function threeDView(appearance) {
    let count = appearance.size / 10;
    let rStep = 0.2;
    let yStep = 3;
    let graphic = new Group();
    for (var i = 0; i < count; i++) {
        const j = (1 - count) / 2 + i;
        const xf = j * (10 + rStep * (count - 1) / 2);
        const xb = j * (10 - rStep * (count - 1) / 2);
        graphic.addChild(new Path.Line(P(xb, 0), P(xf, yStep * (count - 1))).withStroke(2.0, "#5c6c84"));
    }
    // Vertical ones.
    for (var i = 0; i < count; i++) {
        const x = (10 + ((1 - count) / 2 + i) * rStep) * (count - 1) / 2;
        const y = i * yStep;
        graphic.addChild(new Path.Line(P(-x, y), P(x, y)).withStroke(2.0, "#5c6c84"));
    }
    let pad = Shape.Ellipse(R(graphic.bounds.center.x, graphic.bounds.center.y, appearance.size * 0.65, count * yStep * 0.65, Pivot.CENTER));
    pad.fillColor = "#dbcfbaee";
    graphic.addChild(pad);
    var hitShape = Shape.Rectangle(graphic.strokeBounds.expand(10));
    return { graphic: graphic, hitShape: hitShape };
}
